/******************************************************************************************
 SYSTEM NAME       = NetDial-TSP MODULE
 ******************************************************************************************/
/* eslint-disable */

import ndCommon from '@/util/call/neoWebRTC/neoWebRtcAPI/ndCommon';
import cstaDefs from '@/util/call/neoWebRTC/neoWebRtcAPI/cstaDefs';

export default {
  NDMonitorDevice_C,
  NDMonitorCall_C,
  NDMonitorCallsViaDevice_C,
  NDRouteRegisterReq_C,
  NDMonitorFilter_C,
  NDMonitorStop_C,
  NDSetAgentState_C,
  NDGetAGTState_C,
  NDSetMsgWaitingInd_C,
  NDSetDoNotDisturb_C,
  NDSetForwarding_C,
  NDQueryMsgWaitingInd_C,
  NDQueryDoNotDisturb_C,
  NDQueryForwarding_C,
  NDQueryAgentState_C,
  NDQueryLastNumber_C,
  NDQueryDeviceInfo_C,
  NDMakeCall_C,
  NDMakePredictiveCall_C,
  NDAnswerCall_C,
  NDCallCompletion_C,
  NDClearCall_C,
  NDClearConnection_C,
  NDHoldCall_C,
  NDRetrieveCall_C,
  NDConsultationCall_C,
  NDReconnectCall_C,
  NDAlternateCall_C,
  NDTransferCall_C,
  NDConferenceCall_C,
  NDDeflectCall_C,
  NDRouteSelect_C,
  NDSingleStepTransferCall_C,
  NDPickupCall_C,
  NDGroupPickupCall_C,
  NDSendDTMF_C,
  NDEscapeService_C,
  NDMessage_C,
  NDChatDisconnect_C,
  NDMonitorConf_E,
  NDRouteRegisterReqConf_E,
  NDChangeMonitorFilterConf_E,
  NDMonitorEnded_E,
  NDLoggedOn_E,
  NDLoggedOff_E,
  NDNotReady_E,
  NDReady_E,
  NDWorkNotReady_E,
  NDWorkReady_E,
  NDMessageWaiting_E,
  NDDoNotDisturb_E,
  NDSetSpeakerMute_C,
  NDForwarding_E,
  NDQueryMwiConf_E,
  NDQueryDndConf_E,
  NDQueryFwdConf_E,
  NDQueryAgentStateConf_E,
  NDQueryLastNumberConf_E,
  NDQueryDeviceInfoConf_E,
  NDRouteRequest_E,
  NDRouteRequestExt_E,
  NDRouteUse_E,
  NDRouteUseExt_E,
  NDRouteEnd_E,
  NDServiceInitiated_E,
  NDOriginated_E,
  NDDeliveredUEI_E,
  NDDelivered_E,
  NDEstablished_E,
  NDCallCleared_E,
  NDConnectionCleared_E,
  NDRetrieved_E,
  NDTransferred_E,
  NDConferenced_E,
  NDConferencedIVR_E,
  NDQueued_E,
  NDDiverted_E,
  NDNetworkReached_E,
  NDCallInformation_E,
  NDBackInService_E,
  NDOutOfService_E,
  NDFailed_E,
  NDUniversalFailure_E,
  NDMessage_E,
  NDMessage2_E,
  NDEscapeService_E,
  NDCallResult_E,
  NDCallIDChange_E,
  NDScreenPop_E,
  NDChatDisconnect_E,
  NDStatus_C,
  NDService_C,
  NDCallBack_C,
  NDCallResult_C,
  NDGetICDList_C,
  NDGetAGTList_C,
  NDChangeFlag_C,
  NDGetPdsData_C,
  NDITICallLog_I,
  NDDeleteTelNo_C,
  NDInsertTelNo_C,
  NDConnectEXE_C,
  NDLinkCheck_C,
  NDIniInfo_C,
  NDIcdInfo_C,
  NDCampaignInfo_C,
  NDItaInfo_C,
  NDAgentInfo_C,
  NDLineInfo_C,
  NDMonitoring_C,
  NDAgentRequest_I,
  NDAgentRequested_I,
  NDAgentInfo_I,
  NDRequestCancel_I,
  NDMsgOnDemand_I,
  NDAgentDisconnect_I,
  NDClientDisconnect_I,
  NDRequestCancelEX_I,
  NDIVRServiceStatus_C,
  NDGetIcdQueCnt_C,
  NDGetIcdAgtCnt_C,
  NDGetGroupAgentList_C,
  NDAgtRequestRegist_C,
  NDAgtRequestCancle_C,
  NDDeflectRequest_C,
  NDSetWorkMode_C,
  NDPdsSaveCallResult_C,
  NDGetCenterStatus_C,
  NDRecordSaveKey_C,
  NDRecordSaveCallInfo_C,
  NDGetAGTStatus_C,
  NDICDStatus_C
};

function NDMonitorDevice_C() {
  this.dn = 0; // char[20]
  this.monitorFilter = new cstaDefs.CSTAMonitorFilter();
  this.pData = 0; // char[40]
}

function NDMonitorCall_C() {
  this.dn = 0; // char[20]
  this.monitorFilter = new cstaDefs.CSTAMonitorFilter();
  this.monitorCall = new cstaDefs.ConnectionID();
}

function NDMonitorCallsViaDevice_C() {
  this.dn = 0; // char[20]
  this.monitorFilter = new cstaDefs.CSTAMonitorFilter();
}

function NDRouteRegisterReq_C() {
  this.dn = 0; // char[20]
}

function NDMonitorFilter_C() {
  this.dn = 0; // char[20]
  this.monitorFilter = new cstaDefs.CSTAMonitorFilter();
}

function NDMonitorStop_C() {
  this.dn = 0; // char[20]
}

function NDSetAgentState_C() {
  this.dn = 0; // char[20]
  this.agentaMode = 0; // UINT
  this.agentID = 0; // char[13]
  this.agentGroup = 0; // char[10]
  this.agentPass = 0; // char[10]
  this.subStatus = 0; // char[3]
}

function NDGetAGTState_C() {
  this.dn = 0; // char[20]
  this.AgtID = 0; // char[20]
}

function NDSetMsgWaitingInd_C() {
  this.dn = 0; // char[20]
  this.messageWaitingOn = 0; // UINT
}

function NDSetDoNotDisturb_C() {
  this.dn = 0; // char[20]
  this.donotDisturb = 0; // UINT
}

function NDSetForwarding_C() {
  this.dn = 0; // char[20]
  this.fType = 0; // UINT
  this.fOn = 0; // UINT
  this.dest_dn = 0; // char[20]
}

function NDQueryMsgWaitingInd_C() {
  this.dn = 0; // char[20]
}

function NDQueryDoNotDisturb_C() {
  this.dn = 0; // char[20]
}

function NDQueryForwarding_C() {
  this.dn = 0; // char[20]
}

function NDQueryAgentState_C() {
  this.dn = 0; // char[20]
  this.agentGroup = 0; // char[10]
}

function NDQueryLastNumber_C() {
  this.dn = 0; // char[20]
}

function NDQueryDeviceInfo_C() {
  this.dn = 0; // char[20]
}

function NDMakeCall_C() {
  this.dn = 0; // char[20]
  this.dest_dn = 0; // char[20]
  this.userInfo = new ndCommon.ATTUserToUserInfo();
}

function NDMakePredictiveCall_C() {
  this.dn = 0; // char[20]
  this.icd_dn = 0; // char[20]
  this.dest_dn = 0; // char[20]
  this.max_ring = 0; // int
  this.ars_treat = 0; // int
  this.userInfo = new ndCommon.ATTUserToUserInfo();
}

function NDAnswerCall_C() {
  this.dn = 0; // char[20]
  this.alertingCall = new cstaDefs.ConnectionID();
}

function NDCallCompletion_C() {
  this.dn = 0; // char[20]
  this.feature = 0; // UINT
  this.activeCall = new cstaDefs.ConnectionID();
}

function NDClearCall_C() {
  this.dn = 0; // char[20]
  this.activeCall = new cstaDefs.ConnectionID();
}

function NDClearConnection_C() {
  this.dn = 0; // char[20]
  this.activeCall = new cstaDefs.ConnectionID();
}

function NDHoldCall_C() {
  this.dn = 0; // char[20]
  this.activeCall = new cstaDefs.ConnectionID();
}

function NDRetrieveCall_C() {
  this.dn = 0; // char[20]
  this.heldCall = new cstaDefs.ConnectionID();
}

function NDConsultationCall_C() {
  this.dn = 0; // char[20]
  this.activeCall = new cstaDefs.ConnectionID();
  this.dest_dn = 0; // char[20]
  this.userInfo = new ndCommon.ATTUserToUserInfo();
}

function NDReconnectCall_C() {
  this.dn = 0; // char[20]
  this.activeCall = new cstaDefs.ConnectionID();
  this.heldCall = new cstaDefs.ConnectionID();
}

function NDAlternateCall_C() {
  this.dn = 0; // char[20]
  this.activeCall = new cstaDefs.ConnectionID();
  this.heldCall = new cstaDefs.ConnectionID();
}

function NDTransferCall_C() {
  this.dn = 0; // char[20]
  this.heldCall = new cstaDefs.ConnectionID();
  this.activeCall = new cstaDefs.ConnectionID();
}

function NDConferenceCall_C() {
  this.dn = 0; // char[20]
  this.heldCall = new cstaDefs.ConnectionID();
  this.activeCall = new cstaDefs.ConnectionID();
}

function NDDeflectCall_C() {
  this.dn = 0; // char[20]
  this.deflectCall = new cstaDefs.ConnectionID();
  this.dest_dn = 0; // char[20]
  this.userInfo = new ndCommon.ATTUserToUserInfo();
}

function NDRouteSelect_C() {
  this.dn = 0; // char[20]
  this.routingCrossRefID = 0; /* RoutingCrossRefID_t   long */
  this.dest_dn = 0; // char[20]
  this.userInfo = new ndCommon.ATTUserToUserInfo();
}

function NDSingleStepTransferCall_C() {
  this.dn = 0; // char[20]
  this.activeCall = new cstaDefs.ConnectionID();
  this.dest_dn = 0; // char[20]
  this.userInfo = new ndCommon.ATTUserToUserInfo();
}

function NDPickupCall_C() {
  this.dn = 0; // char[20]
  this.deflectCall = new cstaDefs.ConnectionID();
  this.dest_dn = 0; // char[20]
}

function NDGroupPickupCall_C() {
  this.dn = 0; // char[20]
  this.dest_dn = 0; // char[20]
}

function NDSendDTMF_C() {
  this.dn = 0; // char[20]
  this.activeCall = new cstaDefs.ConnectionID();
  this.DTMF = 0; // char[20]
}

function NDEscapeService_C() {
  this.Escape = 0; // char[512]
}

function NDMessage_C() {
  this.dn = 0; // char[20]
  this.dest_id = 0; // char[20]
  this.id_div = 0; // char
  this.Msg = 0; // char[412]
}

function NDChatDisconnect_C() {
  this.dn = 0; // char[20]
}

/* CMD//////////////////////////////////////////////////////////////////////////////////////////// */

function NDMonitorConf_E() {
  this.dn = 0; // char[20]
  this.monitorFilter = new cstaDefs.CSTAMonitorFilter();
}

function NDRouteRegisterReqConf_E() {
  this.dn = 0; // char[20]
  this.routeRegister = new cstaDefs.CSTARouteRegisterReqConfEvent();
}

function NDChangeMonitorFilterConf_E() {
  this.dn = 0; // char[20]
  this.monitorFilter = new cstaDefs.CSTAMonitorFilter();
}

function NDMonitorEnded_E() {
  this.dn = 0; // char[20]
  this.monitorEnded = new cstaDefs.CSTAMonitorEndedEvent();
}

function NDLoggedOn_E() {
  this.dn = 0; // char[20]
  this.loggedOn = new cstaDefs.CSTALoggedOnEvent();
}

function NDLoggedOff_E() {
  this.dn = 0; // char[20]
  this.loggedOff = new cstaDefs.CSTALoggedOffEvent();
}

function NDNotReady_E() {
  this.dn = 0; // char[20]
  this.notReady = new cstaDefs.CSTANotReadyEvent();
}

function NDReady_E() {
  this.dn = 0; // char[20]
  this.ready = new cstaDefs.CSTAReadyEvent();
}

function NDWorkNotReady_E() {
  this.dn = 0; // char[20]
  this.workNotReady = new cstaDefs.CSTAWorkNotReadyEvent();
}

function NDWorkReady_E() {
  this.dn = 0; // char[20]
  this.workReady = new cstaDefs.CSTAWorkReadyEvent();
}

function NDMessageWaiting_E() {
  this.dn = 0; // char[20]
  this.messageWaiting = new cstaDefs.CSTAMessageWaitingEvent();
}

function NDDoNotDisturb_E() {
  this.dn = 0; // char[20]
  this.doNotDisturb = new cstaDefs.CSTADoNotDisturbEvent();
}

function NDSetSpeakerMute_C() {
  this.dn = 0; // char[20]
  this.activeCall = new cstaDefs.ConnectionID();
  this.muteFlag = 0; // UINT
}

function NDForwarding_E() {
  this.dn = 0; // char[20]
  this.forwarding = new cstaDefs.CSTAForwardingEvent();
}

function NDQueryMwiConf_E() {
  this.dn = 0; // char[20]
  this.queryMwi = new cstaDefs.CSTAQueryMwiConfEvent();
}

function NDQueryDndConf_E() {
  this.dn = 0; // char[20]
  this.queryDnd = new cstaDefs.CSTAQueryDndConfEvent();
}

function NDQueryFwdConf_E() {
  this.dn = 0; // char[20]
  this.queryFwd = new cstaDefs.CSTAQueryFwdConfEvent();
}

function NDQueryAgentStateConf_E() {
  this.dn = 0; // char[20]
  this.queryAgentState = new cstaDefs.CSTAQueryAgentStateConfEvent();
}

function NDQueryLastNumberConf_E() {
  this.dn = 0; // char[20]
  this.queryLastNumber = new cstaDefs.CSTAQueryLastNumberConfEvent();
}

function NDQueryDeviceInfoConf_E() {
  this.dn = 0; // char[20]
  this.queryDeviceInfo = new cstaDefs.CSTAQueryDeviceInfoConfEvent();
}

function NDRouteRequest_E() {
  this.dn = 0; // char[20]
  this.routeRequest = new cstaDefs.CSTARouteRequestEvent();
}

function NDRouteRequestExt_E() {
  this.dn = 0; // char[20]
  this.routeRequestExt = new cstaDefs.CSTARouteRequestExtEvent();
  this.userInfo = ndCommon.ATTUserToUserInfo();
}

function NDRouteUse_E() {
  this.dn = 0; // char[20]
  this.routeUsed = new cstaDefs.CSTARouteUsedEvent();
}

function NDRouteUseExt_E() {
  this.dn = 0; // char[20]
  this.routeUsedExt = new cstaDefs.CSTARouteUsedExtEvent();
}

function NDRouteEnd_E() {
  this.dn = 0; // char[20]
  this.routeEnd = new cstaDefs.CSTARouteEndEvent();
}

function NDServiceInitiated_E() {
  this.dn = 0; // char[20]
  this.serviceInitiated = new cstaDefs.CSTAServiceInitiatedEvent();
}

function NDOriginated_E() {
  this.dn = 0; // char[20]
  this.originated = new cstaDefs.CSTAOriginatedEvent();
}

function NDDeliveredUEI_E() {
  this.dn = 0; // char[20]
  this.delivered = new cstaDefs.CSTADeliveredEvent();
  this.userInfo = new ndCommon.ATTUserToUserInfo();
  this.pData = 0; // char[40]
  this.ShelfNo = 0; // char[5]
  this.ChannelNo = 0; // char[5]
  this.IPAddr = 0; // char[16]
  this.CustData = 0; // char[513]
}

function NDDelivered_E() {
  this.dn = 0; // char[20]
  this.delivered = new cstaDefs.CSTADeliveredEvent();
  this.userInfo = new ndCommon.ATTUserToUserInfo();
  this.pData = 0; // char[40]
}

function NDEstablished_E() {
  this.dn = 0; // char[20]
  this.established = new cstaDefs.CSTAEstablishedEvent();
}

function NDCallCleared_E() {
  this.dn = 0; // char[20]
  this.callCleared = new cstaDefs.CSTACallClearedEvent();
}

function NDConnectionCleared_E() {
  this.dn = 0; // char[20]
  this.connectionCleared = new cstaDefs.CSTAConnectionClearedEvent();
}

// TODO CSTAHeldEvent CHECK
// function NDHeld_E () {
//   this.dn = 0 // char[20]
//   this.held = new cstaDefs.CSTAHeldEvent()
// }

function NDRetrieved_E() {
  this.dn = 0; // char[20]
  this.retrieved = new cstaDefs.CSTARetrievedEvent();
}

function NDTransferred_E() {
  this.dn = 0; // char[20]
  this.transferred = new cstaDefs.CSTATransferredEvent();
  this.Connection = new cstaDefs.Connection(); // char[3]
}

function NDConferenced_E() {
  this.dn = 0; // char[20]
  this.conferenced = new cstaDefs.CSTAConferencedEvent();
  this.Connection = new cstaDefs.Connection(); // char[3]
}

function NDConferencedIVR_E() {
  this.dn = 0; // char[20]
  this.conferenced = new cstaDefs.CSTAConferencedEvent();
  this.Connection = new cstaDefs.Connection(); // char[3]
  this.ShelfNo = 0; // char[5]
  this.ChannelNo = 0; // char[5]
  this.IPAddr = 0; // char[16]
}

function NDQueued_E() {
  this.dn = 0; // char[20]
  this.queued = new cstaDefs.CSTAQueuedEvent();
  this.userInfo = new ndCommon.ATTUserToUserInfo();
}

function NDDiverted_E() {
  this.dn = 0; // char[20]
  this.diverted = new cstaDefs.CSTADivertedEvent();
}

function NDNetworkReached_E() {
  this.dn = 0; // char[20]
  this.networkReached = new cstaDefs.CSTANetworkReachedEvent();
}

function NDCallInformation_E() {
  this.dn = 0; // char[20]
  this.callInformation = new cstaDefs.CSTACallInformationEvent();
}

function NDBackInService_E() {
  this.dn = 0; // char[20]
  this.backInService = new cstaDefs.CSTABackInServiceEvent();
}

function NDOutOfService_E() {
  this.dn = 0; // char[20]
  this.outOfService = new cstaDefs.CSTAOutOfServiceEvent();
}

function NDFailed_E() {
  this.dn = 0; // char[20]
  this.failed = new cstaDefs.CSTAFailedEvent();
}

function NDUniversalFailure_E() {
  this.dn = 0; // char[20]
  this.errCode = 0; // unsigned int
}

function NDMessage_E() {
  this.dn = 0; // char[20]
  this.msgCode = 0; // unsigned int
  this.Msg = 0; // char[408]
}

function NDMessage2_E() {
  this.dn = 0; // char[20]
  this.msgCode = 0; // unsigned int
  this.Msg = 0; // char[32768]
}

function NDEscapeService_E() {
  this.Escape = 0; // char[530]
}

function NDCallResult_E() {
  this.dn = 0; // char[20]
  this.call_result = 0; // char
}

function NDCallIDChange_E() {
  this.dn = 0; // char[20]
  this.new_callid = 0; // int
  this.old_callid = 0; // int
  this.established = new cstaDefs.CSTAEstablishedEvent();
}

function NDScreenPop_E() {
  this.dn = 0; // char[20]
  this.PopData = 0; // char[40]
}

function NDChatDisconnect_E() {
  this.dn = 0; // char[20]
}

// EVT/////////////////////////////////////////////////////////////////////////////////////////////////////////////
function NDStatus_C() {
  this.ThisDN = 0; // char[TEL_SIZE + 1]
  this.Major = 0; // char[MAJOR_SIZE + 1]
  this.Minor = 0; // char[MINOR_SIZE + 1]
  this.AgtID = 0; // char[AGTID_SIZE + 1]
  this.longStartTime = 0; // char
  this.longEndTime = 0; // char
  this.Status = 0; // char
  this.SubStatus = 0; // char[SUBSTATUS_SIZE + 1]
}

function NDService_C() {
  this.ThisDN = 0; // char[TEL_SIZE + 1]
  this.SvcCode = 0; // char[SVCCODE_SIZE + 1]
  this.CustID = 0; // char[CUSTID_SIZE + 1]
}

function NDCallBack_C() {
  this.ThisDN = 0; // char[TEL_SIZE + 1]
  this.SvcCode = 0; // char[SVCCODE_SIZE + 1]
  this.CustID = 0; // char[CUSTID_SIZE + 1]
  this.CustTelNo = 0; // char[CUSTTEL_SIZE  + 1]
  this.IcdNo = 0; // char[TEL_SIZE + 1]
  this.BzInzNo = 0; // char[64 + 1]
  this.Msg = 0; // char[64 + 1]
}

function NDCallResult_C() {
  this.ThisDN = 0; // char[TEL_SIZE + 1]
  this.longCallTime = 0; // char
  this.longEndTime = 0; // char
  this.CampaignId = 0; // char[CAMPAIGNID_SIZE + 1]
  this.IcdNo = 0; // char[TEL_SIZE + 1]
  this.CustID = 0; // char[CUSTID_SIZE + 1]
  this.CustTelNo = 0; // char[CUSTTEL_SIZE  + 1]
  this.CallResult = 0; // char
  this.TelDivi = 0; // char
}

function NDGetICDList_C() {
  this.dn = 0; // char[20]
}

function NDGetAGTList_C() {
  this.dn = 0; // char[20]
  this.IcdNo = 0; // char[20]
}

function NDChangeFlag_C() {
  this.CampaignId = 0; // char[CAMPAIGNID_SIZE      + 1]
  this.CustID = 0; // char[CUSTID_SIZE   + 1]
  this.AgtID = 0; // char[AGTID_SIZE    + 1]
  this.CallFlag = 0; // char[4]
}

function NDGetPdsData_C() {
  this.CampaignId = 0; // char[CAMPAIGNID_SIZE + 1]
  this.IcdNo = 0; // char[TEL_SIZE + 1]
  this.CallCount = 0; // int
}

function NDITICallLog_I() {
  this.longReqTime = 0; // char
  this.CustKey = 0; // char[CUSTKEY_SIZE + 1]
  this.longConnectTime = 0; // char
  this.IcdNo = 0; // char[TEL_SIZE + 1]
  this.CustID = 0; // char[CUSTID_SIZE  + 1]
  this.MediaType = 0; // char[MEDIA_SIZE  + 1]
  this.AgentID = 0; // char[AGTID_SIZE + 1]
  this.Major = 0; // char[MAJOR_SIZE + 1]
  this.Minor = 0; // char[MINOR_SIZE + 1]
  this.longDisconnectTime = 0; // char
}

function NDDeleteTelNo_C() {
  this.PbxNode = 0; // char
  this.TelNo = 0; // char[TEL_SIZE + 1]
}

function NDInsertTelNo_C() {
  this.PbxNode = 0; // char
  this.TelNo = 0; // char[TEL_SIZE * 100]
}

function NDConnectEXE_C() {
  this.ProcName = 0; // char[20]
  this.index = 0; // char[5]
}

function NDLinkCheck_C() {
  this.ProcName = 0; // char[20]
  this.index = 0; // char[5]
  this.Status = 0; // char
}

// PRI/////////////////////////////////////////////////////////////////////////////////

function NDIniInfo_C() {
  this.Section = 0; // char[SECTION_SIZE + 1]
  this.Keyword = 0; // char[KEYWORD_SIZE + 1]
  this.Value = 0; // char[INIDATA_SIZE+1]
}

function NDIcdInfo_C() {
  this.InfoFlag = 0; // char
  this.IcdNo = 0; // char[TEL_SIZE + 1]
  this.IcdNm = 0; // char[ICDNM_SIZE + 1]
  this.IOType = 0; // char
  this.RouteType = 0; // char
  this.LevelRate = 0; // int
  this.CallBackNo = 0; // char[TEL_SIZE + 1]
  this.CallBackTime = 0; // int
}

function NDCampaignInfo_C() {
  this.InfoFlag = 0; // char
  this.CampaignId = 0; // char[CAMPAIGNID_SIZE + 1]
  this.CampaignNm = 0; // char[CAMPAIGNNM_SIZE + 1]
  this.Priority = 0; // int
  this.IcdNo = 0; // char[TEL_SIZE+1]
  this.CampaignState = 0; // char
  this.TryRate = 0; // int
  this.RateFlag = 0; // char
  this.DialMode = 0; // char
  this.AvgBusyTime = 0; // int
  this.AvgTryTime = 0; // int
  this.AccessCode = 0; // char[4]
  this.RingCnt = 0; // int
  this.FromDT = 0; // char[DATETIME_SIZE + 1]
  this.ToDT = 0; // char[DATETIME_SIZE +1 ]
  this.QFrom1 = 0; // char[DATETIME_SIZE + 1]
  this.QTo1 = 0; // char[DATETIME_SIZE + 1]
  this.QFrom2 = 0; // char[DATETIME_SIZE + 1]
  this.QTo2 = 0; // char[DATETIME_SIZE + 1]
  this.QFrom3 = 0; // char[DATETIME_SIZE + 1]
  this.QTo3 = 0; // char[DATETIME_SIZE + 1]
  this.QFrom4 = 0; // char[DATETIME_SIZE + 1]
  this.QTo4 = 0; // char[DATETIME_SIZE + 1]
}

function NDItaInfo_C() {
  this.InfoFlag = 0; // char
  this.IcdNo = 0; // char[TEL_SIZE+1]
  this.AgtID = 0; // char[AGTID_SIZE+1]
  this.AgtGrade = 0; // char
  this.VipFlag = 0; // char
  this.AgtLevel = 0; // char
}

function NDAgentInfo_C() {
  this.InfoFlag = 0; // char
  this.AgtID = 0; // char[AGTID_SIZE+1]
  this.AgtNM = 0; // char[AGTNM_SIZE+1]
  this.Major = 0; // char[MAJOR_SIZE+1]
  this.Minor = 0; // char[MINOR_SIZE+1]
  this.LoginID = 0; // char[LOGIN_SIZE+1]
}

function NDLineInfo_C() {
  this.InfoFlag = 0; // char
  this.TelNo = 0; // char[TEL_SIZE+1]
  this.AcdNo = 0; // char[TEL_SIZE+1]
  this.PbxNode = 0; // char
  this.SysNo = 0; // char
  this.LineType = 0; // char
  this.PositionId = 0; // char[TEL_SIZE+1]
}

function NDMonitoring_C() {
  this.Interval = 0; // int
  this.MonitorID = 0; // char[10]
}

// MNG//////////////////////////////////////////////////////////////////////////////////////////////////

function NDAgentRequest_I() {
  // WorkDivi =  0; //char[2+1] //temp
  this.CustKey = 0; // char[CUSTKEY_SIZE + 1]
  this.CustID = 0; // char[CUSTID_SIZE  + 1]
  this.CustLevel = 0; // char
  this.IcdNo = 0; // char[TEL_SIZE     + 1]
  this.Media = 0; // char[MEDIA_SIZE   + 1]
  this.ItiTelNo = 0; // char[TEL_SIZE     + 1]
}

function NDAgentRequested_I() {
  this.CustKey = 0; // char[CUSTKEY_SIZE + 1]
  this.RequestResult = 0; // char
  this.WaitCnt = 0; // char[5]
  this.FailReason = 0; // char
}

function NDAgentInfo_I() {
  this.CustKey = 0; // char[CUSTKEY_SIZE + 1]
  this.Type = 0; // char
  this.AgtTelNo = 0; // char[TEL_SIZE     + 1]
}

function NDRequestCancel_I() {
  this.CustKey = 0; // char[CUSTKEY_SIZE + 1]
}

function NDMsgOnDemand_I() {
  this.CustKey = 0; // char[CUSTKEY_SIZE + 1]
  this.CustID = 0; // char[CUSTID_SIZE + 1]
  this.CustLevel = 0; // char
  this.IcdNo = 0; // char[TEL_SIZE + 1]
  this.ReqDt = 0; // char[DATETIME_SIZE + 1]
  this.Media = 0; // char[MEDIA_SIZE + 1]
  this.Contact = 0; // char[31]
  this.Msg = 0; // char[600]
}

function NDAgentDisconnect_I() {
  this.CustKey = 0; // char[CUSTKEY_SIZE + 1]
  this.AgtTelNo = 0; // char[TEL_SIZE + 1]
}

function NDClientDisconnect_I() {
  this.CustKey = 0; // char[CUSTKEY_SIZE + 1]
}

function NDRequestCancelEX_I() {
  this.IcdIdx = 0; // int
  this.ChtIdx = 0; // int
  this.VipFlag = 0; // char
}

function NDIVRServiceStatus_C() {
  this.dn = 0; // char[TEL_SIZE     + 1]
  this.SType = 0; // char[20]
  this.SName = 0; // char[128]
}

function NDGetIcdQueCnt_C() {
  this.dn = 0; // char[20]
  this.IcdNo = 0; // char[20]
  this.QueCnt = 0; // int
  this.LoginCnt = 0; // int
}

function NDGetIcdAgtCnt_C() {
  this.dn = 0; // char[20]
  this.IcdNo = 0; // char[20]
  this.LoginCnt = 0; // int
  this.ReadyCnt = 0; // int
}

function NDGetGroupAgentList_C() {
  this.dn = 0; // char[20]
  this.major = 0; // char[MAJOR_SIZE + 1]
  this.minor = 0; // char[MINOR_SIZE + 1]
  this.icdNo = 0; // char[TEL_SIZE + 1]
  this.status = 0; // char
  this.substatus = 0; // char[2]
}

function NDAgtRequestRegist_C() {
  this.dn = 0; // char[TEL_SIZE     + 1]
  this.CallID = 0; // int
  this.IcdNo = 0; // char[TEL_SIZE     + 1]
  this.AgentID = 0; // char[AGTID_SIZE+1]
  this.RouteFlag = 0; // char
}

function NDAgtRequestCancle_C() {
  this.dn = 0; // char[TEL_SIZE     + 1]
  this.IcdNo = 0; // char[TEL_SIZE     + 1]
  this.CancleFlag = 0; // char /* 0;= 정상연결 1 =IVR포기 */
}

function NDDeflectRequest_C() {
  this.dn = 0; // char[TEL_SIZE     + 1]
  this.IcdNo = 0; // char[TEL_SIZE     + 1]
}

function NDSetWorkMode_C() {
  this.dn = 0; // char[TEL_SIZE + 1]
  this.AgtID = 0; // char[AGTID_SIZE    + 1]
  this.WorkMode = 0; // char
}

// PDS 결과저장
function NDPdsSaveCallResult_C() {
  this.dn = 0; // char[TEL_SIZE + 1]
  this.AgtID = 0; // char[AGTID_SIZE + 1]
  this.WorkMode = 0; // char[5 + 1]
  this.custId = 0; // char[CUSTID_SIZE + 1]
  this.campaingId = 0; // char[CAMPAIGNID_SIZE + 1]
  this.jobId = 0; // char[JOBID_SIZE + 1]
  this.segmentId = 0; // char[JOBID_SIZE + 1]
  this.phoneType = 0; // char[5 + 1]
  this.talkTime = 0; // char[5 + 1]
  this.result1 = 0; // char[5 + 1]
  this.result2 = 0; // char[5 + 1]
  this.extInfo1 = 0; // char[BUF_128 + 1]
  this.extInfo2 = 0; // char[BUF_128 + 1]
  this.extInfo3 = 0; // char[BUF_128 + 1]
  this.extInfo4 = 0; // char[BUF_128 + 1]
  this.extInfo5 = 0; // char[BUF_128 + 1]
}

function NDGetCenterStatus_C() {
  this.dn = 0; // char[20]
}

// 녹취키저장
function NDRecordSaveKey_C() {
  this.dn = 0; // char[5]
  this.AgtID = 0; // char[13]
  this.recKey = 0; // char[129]
}

// 녹취후처리저장
function NDRecordSaveCallInfo_C() {
  this.dn = 0; // char[5]
  this.AgtID = 0; // char[12]
  this.recKey = 0; // char[129]
  this.extInfo1 = 0; // char[129]
  this.extInfo2 = 0; // char[129]
  this.extInfo3 = 0; // char[129]
  this.extInfo4 = 0; // char[129]
  this.extInfo5 = 0; // char[129]
  this.extInfo6 = 0; // char[129]
  this.extInfo7 = 0; // char[129]
  this.extInfo8 = 0; // char[129]
  this.extInfo9 = 0; // char[129]
  this.extInfo10 = 0; // char[129]
}

function NDGetAGTStatus_C() {
  this.dn = 0; // char[20];
  this.dest_id = 0; // char[20]; // 알고 싶은 상담원 id
  this.id_div = 0; // char // 1 전화번호, 2 AgentId 3, Agent 이름
}

function NDICDStatus_C() {
  this.dn = 0; // char[20 + 1];
  this.ICDNo = 0; // char[20 + 1];
}



// WEBPACK FOOTER //
// ./src/util/call/neoWebRTC/neoWebRtcAPI/ndDefs.js